import { useMemo } from 'react';
import { renderContract, sanitizeHtml } from '../utils/renderContract';

/**
 * Renders a contract template + context as styled on-screen HTML.
 *
 * Used by:
 *   - AgreementsPage (live preview while editing)
 *   - BookingEngineModal (pre-sign view)
 *   - CheckInModal (sign-at-desk view)
 *   - AddLeaseModal (lease sign view)
 *   - CustomerProfileModal (post-sign viewer)
 *   - RentalHistoryPage (post-sign viewer)
 *
 * Pass `prerenderedHtml` to render a saved snapshot (post-sign), or
 * pass `template` + `context` to render live.
 */
export default function ContractDocument({
  template,
  context,
  prerenderedHtml,
  paperLook = true,
  style,
}) {
  const html = useMemo(() => {
    if (prerenderedHtml) return sanitizeHtml(prerenderedHtml);  // sanitize saved snapshots too
    if (!template) return '';
    return renderContract(template, context || {});               // already sanitized
  }, [template, context, prerenderedHtml]);

  return (
    <div
      className="contract-document"
      style={{
        background: paperLook ? '#fff' : 'transparent',
        color: '#222',
        fontFamily: "'Segoe UI', Arial, sans-serif",
        fontSize: 13,
        lineHeight: 1.65,
        padding: paperLook ? '32px 36px' : 0,
        borderRadius: paperLook ? 8 : 0,
        boxShadow: paperLook ? '0 1px 3px rgba(0,0,0,0.06), 0 0 0 1px rgba(0,0,0,0.04)' : 'none',
        ...style,
      }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
